import Layout from '../../components/layout/Layout';
import PageCard from '../../components/ui/PageCard';
import packageJson from '../../../package.json';

const appVersion = packageJson.version;
const appName = packageJson.name;
const environment = process.env.NODE_ENV ?? 'development';
const apiUrl = process.env.REACT_APP_SERVER_URL ?? 'Not configured';

const infoRows = [
  { label: 'Application', value: 'TORCH Admin' },
  { label: 'Package', value: appName },
  { label: 'Version', value: appVersion },
  { label: 'Environment', value: environment },
  { label: 'API URL', value: apiUrl },
];

const System = () => (
  <Layout>
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-gray-900">System</h1>
      <p className="mt-1 text-sm text-gray-500">
        Maintenance overview and application details.
      </p>
    </div>

    <PageCard>
      <h2 className="mb-4 text-lg font-medium text-gray-800">Application info</h2>
      <dl className="divide-y divide-gray-100">
        {infoRows.map((row) => (
          <div
            key={row.label}
            className="flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:justify-between"
          >
            <dt className="text-sm font-medium text-gray-500">{row.label}</dt>
            <dd className="text-sm text-gray-900 sm:text-right">{row.value}</dd>
          </div>
        ))}
      </dl>
    </PageCard>

    <PageCard className="mt-6">
      <h2 className="mb-2 text-lg font-medium text-gray-800">Status</h2>
      <p className="text-sm text-gray-600">
        All systems operational. This page is for admin maintenance reference only.
      </p>
    </PageCard>
  </Layout>
);

export default System;
